import { createStore } from "@virgodev/vue-models/utils/create_store";

export interface FAQs {
  id: number;
  updated: string;
  created: string;
  topic: string;
  content: string;
  answer: string;
}

export const useFAQsStore = createStore<FAQs>("faqs");
